/**
 * FilterToggle Component
 *
 * Boolean toggle/checkbox filter.
 */

import React from 'react';
import { FilterToggleProps } from './types';

export function FilterToggle({
  value,
  onChange,
  label,
  disabled = false,
  className = '',
}: FilterToggleProps) {
  return (
    <label
      className={`
        inline-flex items-center gap-2 cursor-pointer select-none
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}
      `}
    >
      <input
        type="checkbox"
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className={`
          h-4 w-4
          text-purple-600
          border-gray-300 rounded
          focus:ring-purple-500 focus:ring-offset-0
          disabled:cursor-not-allowed
          transition-colors
        `}
      />
      <span className="text-sm text-gray-700">{label}</span>
    </label>
  );
}

export default FilterToggle;
